<template>
  <v-main>
    <v-container fluid>
      <!-- Generamos el AppBar con las distintas acciones -->
      <v-app-bar color="primary" dense dark style="border-radius: 5px">
        <!-- Crear una nuevo servicio -->
        <v-btn v-if="show_btn_crear_servicio" text @click="open_dialog()">
          <v-icon>mdi-file-outline</v-icon>
          <span class="appbar_button">{{ $t('Nuevo') }}</span>
        </v-btn>
        <!-- Imprimir servicios -->
        <v-btn :disabled="active_tab!=='tab-servicios'" text @click="print_servicios">
          <v-icon>mdi-printer</v-icon>
          <span class="appbar_button">{{ $t('Imprimir') }}</span>
        </v-btn>
        <!-- Exportar servicios -->
        <v-btn :disabled="active_tab!=='tab-servicios' || delay_exportar" text @click="exportar()">
          <v-icon>mdi-cloud-download-outline</v-icon>
          <span class="appbar_button">{{ $t('Exportar') }}</span>
        </v-btn>
        <!-- Importar servicios -->
        <v-btn :disabled="active_tab!=='tab-servicios'" text @click="form_importar_servicios = !form_importar_servicios">
          <v-icon>mdi-cloud-upload-outline</v-icon>
          <span class="appbar_button">{{ $t('Importar') }}</span>
        </v-btn>
        <!-- Reordenar servicios -->
        <v-btn v-if="active_tab==='tab-servicios' && this.$store.state.auth.user.tipo_empleado === 'admin'" text @click="open_dialog_reordenar">
          <v-icon>mdi-reload</v-icon>
          <span class="appbar_button">{{ $t('Reordenar') }}</span>
        </v-btn>
        <v-spacer />
        <Tutoriales/>
      </v-app-bar>

      <v-row v-if="active_tab==='tab-servicioscombinados'">
        <v-col cols="12">
          <div class="container_info_azul">
            <p>{{ $t("Los servicios combinados te permiten intercalar tiempo de espera entre servicios") }}.</p>
          </div>
        </v-col>
      </v-row>

      <!-- Tab del apartado -->
      <v-tabs v-model="active_tab" class="elevation-2 pa-2" grow>
        <!-- Apartado de tabla de servicios -->
        <!-- Cabecera del tab -->
        <v-tab href="#tab-servicios">
          <span class="tab_title">{{ $t('Servicios') }}</span>
        </v-tab>
        <!-- Contenido del tab -->
        <v-tab-item value="tab-servicios" class="pa-4 grey lighten-5">
          <BuscarServicios v-if="active_tab==='tab-servicios'" ref="buscar_servicios" />
        </v-tab-item>

        <!-- Apartado de servicios combinados -->
        <!-- Cabecera del tab -->
        <v-tab href="#tab-servicioscombinados">
          <span class="tab_title">{{ $t("Servicios combinados") }}</span>
        </v-tab>
        <!-- Contenido del tab -->
        <v-tab-item value="tab-servicioscombinados" class="pa-4 grey lighten-5">
          <ServiciosCombinados v-if="active_tab==='tab-servicioscombinados'" ref="servicios_combinados" />
        </v-tab-item>
      </v-tabs>
    </v-container>

    <ImportarServicios
      v-model="form_importar_servicios"
      v-if="form_importar_servicios"
      @on_importar="get_servicios()"
    />

    <Reordenar
        v-if="dialog_reordenar"
        v-model="dialog_reordenar"
        tipo="servicio"
        @on_reordenar="get_servicios"
    />

  </v-main>
</template>

<script>

export default {
  name: "Servicios",

  data: () => ({
    active_tab: "tab-servicios",
    form_importar_servicios: false,
    dialog_reordenar: false,
    delay_exportar: false,
  }),

  methods: {

    /**
     * Abre el dialog servicio o servicio combinado según el tab actual
     */
    open_dialog(){
      if(this.active_tab === 'tab-servicioscombinados'){
        this.open_dialog_servicio_combinado(null)
      }else {
        this.open_dialog_servicio()
      }
    },

    /**
     * Abre el dialog servicio del componente hijo
     */
    open_dialog_servicio() {
      this.$refs.buscar_servicios.open_dialog_servicio()
    },

    /**
     * Abre el dialog servicio combinado del componente hijo
     */
    open_dialog_servicio_combinado() {
      this.$refs.servicios_combinados.open_dialog_servicio_combinado(null)
    },

    /**
     * Exporta los serivicos a excel
     */
    async exportar() {
      if(this.delay_exportar) return
      try {
        this.delay_exportar = true
        await this.$store.dispatch("servicio/exportar", this.$refs.buscar_servicios.selected_filters);
      } catch (e) {
        if (e.message.slice(e.message.length-3) === '418') {
          this.$snotify.info(
              this.$t("Exportación en curso. Se enviará al correo de tu centro cuando finalice. Tiempo estimado: 5 minutos."),
              this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name]),
              {hideDuration: 500}
          )
        } else {
          this.$snotify.error(
              this.$t("Ha ocurrido un error"),
              this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
          )
        }
      }

      const func = () => {
        this.delay_exportar = false
      }
      setTimeout(func,3000);
    },
    // Abre el formulario de servicio
    open_dialog_reordenar() {
      this.dialog_reordenar = true
    },

    async print_servicios() {

      // Obtenemos los filtros del componente hijo (BuscarServicios)
      let selected_filters = this.$refs.buscar_servicios.selected_filters
      let filtros = { ...selected_filters }

      // Preparamos los filtros del buscador
      filtros['categoria__id__in'] = selected_filters['categoria'].join(",")

      try{
        await this.$store.dispatch("servicio/imprimir", {
          params: filtros
        })
      }catch (err){
        this.$snotify.error(
            this.$t("Ha ocurrido un error"),
            this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
        )
      }
    },

    get_servicios() {
      this.$refs.buscar_servicios.get_servicios()
    }
  },

  computed: {
    show_btn_crear_servicio(){
      if(this.$store.state.auth.user.tipo_empleado === 'admin'){
        return true
      }else{
        if(this.$store.getters['auth/has_permission']("crear_concepto_venta")){
          return true
        }
      }
      return false

    }
  },

  components: {
    BuscarServicios: () => import("@/views/Configuracion/Servicios/Servicios/BuscarServicios"),
    ServiciosCombinados: () => import("@/views/Configuracion/Servicios/ServiciosCombinados/ServiciosCombinados"),
    ImportarServicios: () => import("@/views/Configuracion/Servicios/Servicios/components/ImportarServicios"),
    Reordenar: () => import("@/views/Configuracion/Reordenar")
  }
};
</script>
